import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ASSOCIATION } from '../../_config/association';

export interface SeoData {
  title: string;
  description: string;
  /** Chemin de la page, par exemple "/a-propos". */
  path: string;
  /** Empêche l'indexation (pages sans intérêt pour les moteurs). */
  noindex?: boolean;
}

const DEFAULT_IMAGE = `${ASSOCIATION.siteUrl}/assets/images/photo-4.jpeg`;

@Injectable({ providedIn: 'root' })
export class SeoService {
  private title = inject(Title);
  private meta = inject(Meta);
  private document = inject(DOCUMENT);

  set({ title, description, path, noindex = false }: SeoData): void {
    const fullTitle = title === ASSOCIATION.nom ? title : `${title} | ${ASSOCIATION.nom}`;
    const url = `${ASSOCIATION.siteUrl}${path}`;

    this.title.setTitle(fullTitle);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ name: 'robots', content: noindex ? 'noindex, follow' : 'index, follow' });
    this.meta.updateTag({ property: 'og:title', content: fullTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:image', content: DEFAULT_IMAGE });
    this.meta.updateTag({ name: 'twitter:title', content: fullTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: DEFAULT_IMAGE });
    this.setCanonical(url);
  }

  private setCanonical(url: string): void {
    let link = this.document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }
}
